import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Content } from 'ionic-angular';
import { ConversaUsaurio } from '../../models/area';
import { ConversaArea } from '../shared/conversa/conversa-area';
import { MensagemProvider } from '../../providers/mensagem/mensagem';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';
import { Mensagem, ArquivoMensagem } from '../../models/mensagem';
import { BrComService } from '../../service/BrComService';
import { FotoProvider } from '../../providers/foto/foto';
import { AreaProvider } from '../../providers/area/area';
import { AreaAdminLocalProvider } from '../../providers/area-admin-local/area-admin-local';

@IonicPage()
@Component({
  selector: 'page-conversa-area-usuario',
  templateUrl: 'conversa-area-usuario.html',
})
export class ConversaAreaUsuarioPage extends ConversaArea {

  @ViewChild(Content) content: Content;
  public conversaUsuario: ConversaUsaurio;
  private idArea: number;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private events: Events,
    private areaProvider: AreaProvider,
    private areaAdminLocalProvider: AreaAdminLocalProvider,
    private changeDetectorRef: ChangeDetectorRef,
    brComService: BrComService,
    mensagemProvider: MensagemProvider,
    fotoProvider: FotoProvider,
    empresaLocalProvider: EmpresaLocalProvider) {
    super(mensagemProvider, empresaLocalProvider, brComService, fotoProvider);
    this.conversaUsuario = this.navParams.get('conversaUsuario');
    this.idArea = this.navParams.get('idArea');
    this.events.subscribe(`msg.area.${this.idArea}.${this.conversaUsuario.idUsuario}`, (mensagem: Mensagem) => {
      this.conversaUsuario.mensagens.push(mensagem);
      this.changeDetectorRef.detectChanges();
      this.scrollBottom(this.content);
      this.notificarMensagemLida();
    });
  }

  async ionViewWillEnter() {
    setTimeout(() => {
      this.content.scrollToBottom(0);
    }, 50);
    this.brComService.confirmaUsuarioLogado(this.empresa.CodEmpresa, this.empresa.CodUsuario);
    this.notificarMensagemLida();
  }

  ionViewWillLeave() {
   // this.bsEmpresa.unsubscribe();
    this.events.unsubscribe(`msg.area.${this.idArea}.${this.conversaUsuario.idUsuario}`);
    this.areaAdminLocalProvider.removerMensagensAcimaDoLimite(this.idArea, this.conversaUsuario.idUsuario);
  }

  private notificarMensagemLida(): void {
    if (this.hasMensagensNaoLidas()) {
      this.areaAdminLocalProvider.marcarMensagensLidas(this.idArea, this.conversaUsuario.idUsuario);
      this.areaProvider.notificarMensagensAreaAdminLidas(this.conversaUsuario.idUsuario, this.empresa.IdUsuario, this.brComService.getIdDevice(), this.idArea).subscribe();
    }
  }

  private hasMensagensNaoLidas(): boolean {
    const result = this.conversaUsuario.mensagens.find(m => m.origem === "L" && !m.statusMensagemLida)
    if (result) {
      return true;
    }
    return false;
  }

  private adicionarNovaMensagem(msg: Mensagem): void {
    if (!this.conversaUsuario.mensagens) {
      this.conversaUsuario.mensagens = [];
    }
    this.conversaUsuario.mensagens.push(msg);
    this.changeDetectorRef.detectChanges();
    this.scrollBottom(this.content);
    this.areaAdminLocalProvider.adicionarNovaMensagem(this.idArea, this.conversaUsuario.idUsuario, msg);
  }

  private atualizarMensagemComFalhaNoEnvio(msg: Mensagem) {
    this.conversaUsuario.mensagens.find(m => m.idEnvio === msg.idEnvio).falhaNoEnvio = true;
    this.changeDetectorRef.detectChanges();
    // se a a conversa está no fim seria legal dar um scroll, caso contrario não fazer nada
    this.areaAdminLocalProvider.atualizarMensagem(this.idArea, this.conversaUsuario.idUsuario, msg);
  }

  public enviarMensagem(mensagem: string): void {
    if (mensagem.trim() !== "") {
      const idUsuarioDestino = 0;
      const msg = this.criarMensagemSimplesEnvio(mensagem, idUsuarioDestino);
      this.adicionarNovaMensagem(msg);
      this.enviarMensagemUsuario(msg);
    } 
  }

  private enviarMensagemUsuario(msg: Mensagem): void {
    this.areaProvider.enviarMensagemSimplesResposta(this.empresa.IdUsuario, this.conversaUsuario.idUsuario, this.idArea, this.brComService.getIdDevice(), msg.mensagem).subscribe(
      (idEnvio: number) => {
        this.areaAdminLocalProvider.atualizarMensagemEnviada(this.idArea, this.conversaUsuario.idUsuario, msg.idEnvio, idEnvio);
        this.conversaUsuario.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  public async enviarArquivo(file: File): Promise<void> {
    const arquivo: ArquivoMensagem = {
      nome: file.name,
      mime: file.type,
      link: ""
    }
    const idUsuarioDestino = 0;
    const msg = this.criarMensagemArquivoEnvio(idUsuarioDestino, arquivo);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(file).then(
      url => {
        msg.arquivo.link = url;
        const i = this.conversaUsuario.mensagens.findIndex(m => m.idEnvio === msg.idEnvio);
        this.conversaUsuario.mensagens[i] = msg;
        this.areaAdminLocalProvider.atualizarMensagem(this.idArea, this.conversaUsuario.idUsuario, msg);
        this.enviarMensagemArquivo(msg);
      }, error => {
        console.log(error);
      }
    );
  }

  private enviarMensagemArquivo(msg: Mensagem): void {
    this.areaProvider.enviarMensagemArquivoResposta(this.empresa.IdUsuario, this.conversaUsuario.idUsuario, this.idArea, this.brComService.getIdDevice(), msg.arquivo).subscribe(
      (idEnvio: number) => {
        this.areaAdminLocalProvider.atualizarMensagemEnviada(this.idArea, this.conversaUsuario.idUsuario, msg.idEnvio, idEnvio);
        this.conversaUsuario.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  public enviarImagem(imagem: File): void {
    const idUsuarioDestino = 0;
    const msg = this.criarMensagemImagemEnvio(idUsuarioDestino);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(imagem).then(
      url => {
        msg.link = url;
        const i = this.conversaUsuario.mensagens.findIndex(m => m.idEnvio === msg.idEnvio);
        this.conversaUsuario.mensagens[i] = msg;
        this.areaAdminLocalProvider.atualizarMensagem(this.idArea, this.conversaUsuario.idUsuario, msg);
        this.enviarMensagemImagem(msg);
      }, error => {
        console.log(error)
      }
    )
  }

  private enviarMensagemImagem(msg: Mensagem): void {
    this.areaProvider.enviarMensagemImagemResposta(this.empresa.IdUsuario, this.conversaUsuario.idUsuario, this.idArea, this.brComService.getIdDevice(), msg.link).subscribe(
      (idEnvio: number) => {
        this.areaAdminLocalProvider.atualizarMensagemEnviada(this.idArea, this.conversaUsuario.idUsuario, msg.idEnvio, idEnvio);
        this.conversaUsuario.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  public trackBy(index: number, msg: Mensagem): any {
    if(!msg) {
      return null;
    }
    return  `${index}:${msg.statusMensagemRecebida}:${msg.statusMensagemLida}:${msg.pendente}:${msg.falhaNoEnvio}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/conversa-area-usuario/conversa-area-usuario.ts